// import React from 'react';
// import LinearProgress from '@mui/material/LinearProgress';
// import { makeStyles } from '@mui/styles';

// const useStyles = makeStyles({
//   root: {
//     // height: 10,
//     backgroundColor: '#e0e0e0', // Background color of the progress bar
//   },
//   bar: {
//     borderRadius: 5,
//     backgroundColor: '#49ae46', // Custom color for the progress bar
//   },
// });

// const FormLoader = ({ msg }) => {
//   const classes = useStyles();

//   return (
//     <React.Fragment>
//       <div className="LinearProgress">
//         <LinearProgress
//           classes={{ root: classes.root, bar: classes.bar }}
//           thickness={2}
//         />
//       </div>
//     </React.Fragment>
//   );
// };

// export default FormLoader;


import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';

const FormLoader = ({ msg }) => {
  return (
    <React.Fragment>
      <div className="LinearProgress">
        <LinearProgress
          sx={{
            backgroundColor: '#e0e0e0',
            '& .MuiLinearProgress-bar': {
              borderRadius: 5,
              backgroundColor: '#49ae46',
            },
          }}
          thickness={2}
        />
      </div>
    </React.Fragment>
  );
};

export default FormLoader; 